module.exports = __webpack_public_path__ + "MscGameTechnology-38575ef1.webp";